module.exports = __webpack_public_path__ + "static/media/home.86fa3e00.jpg";